module.exports = __webpack_public_path__ + "static/media/error.0814c022.jpg";